


















































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { DistributorModel, DistributorsClient } from "@/diamond-support-api";

@Component
export default class AssociatePersonalEnrollments extends Vue {
  shown = true;

  drawer = null;
  search = "";

  enrollments: DistributorModel[] | null = [];
  distributorApi = new DistributorsClient();
  loadingTable = false;

  headers: any[] = [
    {
      text: "Distributor Id",
      align: "start",
      sortable: true,
      value: "distributorId",
    },
    {
      text: "Associate Status",
      value: "associateStatus",
    },
    {
      text: "Lifetime Rank",
      value: "lifetimeRank",
    },
    {
      text: "Full Name",
      value: "fullName",
    },
    {
      text: "CO-APP Full Name",
      value: "coApplicantFullName",
    },
    {
      text: "Business Name",
      value: "businessName",
    },
    {
      text: "Mobile Phone",
      value: "mobilePhone",
    },
    {
      text: "Second Phone",
      value: "secondPhone",
    },
    {
      text: "Email",
      value: "email",
    },
    {
      text: "Enrollment Date",
      value: "enrollmentDate",
    },
    {
      text: "Renewal Date",
      value: "renewalDate",
    },
  ];

  async mounted() {
    this.loadingTable = true;
    this.enrollments = await this.distributorApi.getEnrollments(
      this.$route.params.id
    );
    this.loadingTable = false;
  }

   @Watch("shown")
  onShownChanged() {
    if (!this.shown)
      this.$router.push(`/associates/${this.$route.params.id}/detail`);
  }
}
